module.exports = __webpack_public_path__ + "img/fruitsetlegumes.92ca4b05.png";